/** Belge talepleri metinleri. */

import type { TranslationBundle } from '../../shell/bridge.ts';

export const KIND_LABEL: Record<string, string> = {
  invoice_sales: 'Invoice (sales)',
  invoice_purchase: 'Invoice (purchase)',
  receipt: 'Receipt',
  bank_statement: 'Bank statement',
  other: 'Other financial document',
};

export const TEXTS: TranslationBundle = {
  en: {
    dr_title: 'Pending requests',
    dr_from: 'From your accountant',
    dr_due: 'due',
    dr_upload: 'Upload',
    dr_uploading: 'Uploading…',
    dr_done: 'Uploaded. Your accountant can see it now.',
    dr_all_done: 'All requested documents were sent. Thank you.',
    dr_fail: 'The upload failed. Please try again.',
    dr_type: 'This file type is not supported.',
    dr_size: 'The file is too large (max 20 MB).',
    dr_signin: 'Please sign in again.',
    dr_orb_one: 'Your accountant is waiting for one document. You can upload it from Home.',
    dr_orb_many: 'Your accountant is waiting for {n} documents. You can upload them from Home.',
  },
};
